import { all } from "redux-saga/effects";
import IncbotFeedbackSaga from "./incbotFeedbackSaga";

export default function* rootSaga(): Generator<any, void, any> {
  yield all([IncbotFeedbackSaga()]);
}
